import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { contactConfig } from '../../config/contact'

function GetInTouch() {
    const { t } = useTranslation()
    
    return (
        <div className="space">
            <div className="container">
                <div className="title-area text-center">
                    <span className="sub-title">{t("contact.getInTouch")}</span>
                    <h2 className="sec-title">{t("contact.contactInfo")}</h2>
                </div>
                <div className="row gy-4 justify-content-center">
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid style2">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/location-dot2.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">{t("contact.address")}</h6>
                                <p className="about-contact-details-text">
                                    {contactConfig.address.line1}
                                </p>
                                <p className="about-contact-details-text">{contactConfig.address.line2}</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/call.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">{t("contact.phone")}</h6>
                                <p className="about-contact-details-text">
                                    <Link to={`tel:${contactConfig.phone.primary.replace(/[^0-9]/g, '')}`}>{contactConfig.phone.primary}</Link>
                                </p>
                                <p className="about-contact-details-text">
                                    <Link to={`tel:${contactConfig.phone.secondary.replace(/[^0-9]/g, '')}`}>{contactConfig.phone.secondary}</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4 col-lg-6">
                        <div className="about-contact-grid">
                            <div className="about-contact-icon">
                                <img src="/assets/img/icon/mail.svg" alt="" />
                            </div>
                            <div className="about-contact-details">
                                <h6 className="box-title">{t("contact.email")}</h6>
                                <p className="about-contact-details-text">
                                    <Link to={`mailto:${contactConfig.email.primary}`}>{contactConfig.email.primary}</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default GetInTouch
